import React from 'react';
import { ShowButton, SelectInput, Filter, Datagrid, TextField, FunctionField, DateField } from 'react-admin';
import TList from '../../components/wrapper/TList';
import PaymentInstrumentListActions from './PaymentInstrumentListActions';

const paymentInstrumentStatusForSelection = ['Created', 'Active', 'Locked', 'Invalid', 'Deleted'].map(key => {
	return { id: key, name: key };
});

const paymentInstrumentTypeForSelection = ['CreditCard', 'BankAccount', 'CryptoWallet', 'ExternalAccount'].map(key => {
	return { id: key, name: key };
});

const PaymentInstrumentFilter = props => (
	<Filter {...props}>
		<SelectInput
			alwaysOn
			resettable
			label="resources.paymentInstruments.filter.type"
			source="paymentInstrumentType"
			choices={paymentInstrumentTypeForSelection}
		/>
		<SelectInput
			alwaysOn
			resettable
			label="resources.paymentInstruments.filter.status"
			source="paymentInstrumentStatus"
			choices={paymentInstrumentStatusForSelection}
		/>
	</Filter>
);

const PaymentInstrumentList = props => {
	return (
		<TList {...props} sort={{ field: 'id', order: 'DESC' }} filters={<PaymentInstrumentFilter />} actions={<PaymentInstrumentListActions />}>
			<Datagrid>
				<ShowButton/>
				<TextField source="id" />
				<DateField source="creationDateTime" showTime />
				<FunctionField
					source="displayValue"
					render={record => (
						<span>
							{record.displayValue}
							<br />
							{record.id}
						</span>
					)}
				/>
				<TextField source="paymentInstrumentType" />
				<TextField source="paymentInstrumentStatus" />
				<TextField source="paymentInstrumentVerificationStatus" />
			</Datagrid>
		</TList>
	);
};

export default PaymentInstrumentList;
